module.exports = __webpack_public_path__ + "static/media/fishing.99923409.webp";